module.exports = "/_next/static/images/banner_app_en-ff0277c44a47e5cbe8cc411b4f30e8b2.jpg";